import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import store from './redux-toolkit/store/store';
import './utilities/axiosInterceptor';
import "tw-elements-react/dist/css/tw-elements-react.min.css";
import { BrowserRouter } from 'react-router-dom';
import { BrandingProvider } from './context/BrandingContext';
import { PermissionProvider } from './context/PermissionContext';

// The codebase has 1600+ console.log calls on hot paths (renders, requests).
// Logging serializes objects and badly slows the app when DevTools is open —
// silence noisy log levels in production; warnings and errors stay visible.
if (process.env.NODE_ENV === 'production') {
  const noop = () => { };
  console.log = noop;
  console.debug = noop;
  console.info = noop;
}

const root = ReactDOM.createRoot(document.getElementById('root'));

// BrandingProvider resolves the product name/theme from the API before the first
// paint of the login screen. PermissionProvider needs the redux store, so it
// sits inside <Provider>.
root.render(
  <Provider store={store}>
    <BrandingProvider>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <PermissionProvider>
          <App />
        </PermissionProvider>
      </BrowserRouter>
    </BrandingProvider>
  </Provider>,
);
